import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-290cfa56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-other" }
const _hoisted_2 = { class: "page-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更新")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        "label-col": { span: 4 },
        "wrapper-col": { span: 20 },
        labelAlign: "right"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCustomFields, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_form_item, {
              key: item.id,
              label: item.customField.title
            }, {
              default: _withCtx(() => [
                (item.type === 'text' || item.type === 'number' || item.type === 'phone' || item.type === 'email' || item.type === 'regexp' || item.type === 'decimal')
                  ? (_openBlock(), _createBlock(_component_a_input, {
                      key: 0,
                      value: item.value,
                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                      placeholder: item.customField.notes,
                      disabled: !item.customField.required && item.customField.edit_able === 0
                    }, null, 8, ["value", "onUpdate:value", "placeholder", "disabled"]))
                  : (item.type === 'textarea')
                    ? (_openBlock(), _createBlock(_component_a_textarea, {
                        key: 1,
                        value: item.value,
                        "onUpdate:value": ($event: any) => ((item.value) = $event),
                        placeholder: item.customField.notes,
                        rows: 4,
                        disabled: !item.customField.required && item.customField.edit_able === 0
                      }, null, 8, ["value", "onUpdate:value", "placeholder", "disabled"]))
                    : (item.type === 'checkbox')
                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                          key: 2,
                          checked: item.value,
                          "onUpdate:checked": ($event: any) => ((item.value) = $event),
                          disabled: !item.customField.required && item.customField.edit_able === 0
                        }, null, 8, ["checked", "onUpdate:checked", "disabled"]))
                      : (item.type === 'options')
                        ? (_openBlock(), _createBlock(_component_a_select, {
                            key: 3,
                            value: item.value,
                            "onUpdate:value": ($event: any) => ((item.value) = $event),
                            disabled: !item.customField.required && item.customField.edit_able === 0
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.customField.customFieldOptions, (it) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: it.value,
                                  label: it.name,
                                  value: it.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(it.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["value", "onUpdate:value", "disabled"]))
                        : (item.type === 'multi_options')
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 4,
                              mode: "multiple",
                              value: item.value,
                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                              disabled: !item.customField.required && item.customField.edit_able === 0
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.customField.customFieldOptions, (it) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: it.value,
                                    label: it.name,
                                    value: it.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(it.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "disabled"]))
                          : (item.type === 'cascade_options')
                            ? (_openBlock(), _createBlock(_component_a_cascader, {
                                key: 5,
                                value: item.value,
                                "onUpdate:value": ($event: any) => ((item.value) = $event),
                                fieldNames: {label: 'name'},
                                options: item.customField.customFieldOptions,
                                disabled: !item.customField.required && item.customField.edit_able === 0
                              }, null, 8, ["value", "onUpdate:value", "options", "disabled"]))
                            : (item.type === 'date')
                              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                                  value: item.value,
                                  "onUpdate:value": ($event: any) => ((item.value) = $event),
                                  format: _ctx.formatDate,
                                  "value-format": _ctx.formatDate,
                                  placeholder: item.customField.notes,
                                  style: {"width":"100%"},
                                  key: index,
                                  disabled: !item.customField.required && item.customField.edit_able === 0
                                }, null, 8, ["value", "onUpdate:value", "format", "value-format", "placeholder", "disabled"]))
                              : (item.type === 'date_time')
                                ? (_openBlock(), _createBlock(_component_a_date_picker, {
                                    value: item.value,
                                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                                    format: _ctx.formatDateTime,
                                    "value-format": _ctx.formatDateTime,
                                    showTime: "",
                                    placeholder: item.customField.notes,
                                    style: {"width":"100%"},
                                    key: index,
                                    disabled: !item.customField.required && item.customField.edit_able === 0
                                  }, null, 8, ["value", "onUpdate:value", "format", "value-format", "placeholder", "disabled"]))
                                : (item.type === 'date_to_date')
                                  ? (_openBlock(), _createBlock(_component_a_range_picker, {
                                      value: item.value,
                                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                                      format: _ctx.formatDate,
                                      "value-format": _ctx.formatDate,
                                      placeholder: item.customField.notes,
                                      style: {"width":"100%"},
                                      key: index,
                                      disabled: !item.customField.required && item.customField.edit_able === 0
                                    }, null, 8, ["value", "onUpdate:value", "format", "value-format", "placeholder", "disabled"]))
                                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        onClick: _ctx.handleSubmit,
        type: "primary",
        disabled: !_ctx.hasPermission('engieer_update'),
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ], 64))
}